/* @flow */

import {
  disableLoginLinkFeature,
  klikPlugin,
  githubProfileFeature,
  onboardingIntroAFeature,
  marketPromptsFeature,
  selfCheckInPlugin,
  manualAvailabilityFeature,
  lightThemeFeature,
  customFontPlugin,
  emailPlugin,
  smsPlugin,
  doubleDutchPlugin,
  signupPlugin,
  slackPlugin,
  iframeIntegrationPlugin,
  googleSyncPlugin,
  outlookSyncPlugin,
  helpFeature,
  hideAccountPrefsFeature,
  moderationPlugin,
  customMenuPlugin,
  topicDisclaimerPlugin,
  videoCallPlugin,
  provideFeedbackSectionFeature,
  conversationFormatsPlugin,
  userRecommendationFeature,
  fishbowlHotseat,
  fishbowlFeature,
  ssoPlugin,
  groupMessageModalFeature,
  interestBasedBraindatingFeature,
  trendingKeywordsSectionFeature,
  virtualBraindateRecordingPlugin,
  expressionOfGratitudePlugin,
  accessibilityCompatibleFeature,
  topicRecommendationFeature,
  transcribePlugin,
  userOnboardingFeature,
} from 'src/shared/app/feature/settings/featureSettings';

export function createFeatureRouter() {
  let internalConfig = {};

  return {
    setFeature(featureName: string, isEnabled: boolean): void {
      internalConfig[featureName] = isEnabled;
    },
    isFeatureEnabled(featureName: string): boolean {
      return internalConfig[featureName];
    },
    reset(): void {
      internalConfig = {};
    },
  };
}

export function createFeatureDecisions(featureRouter: Object): {
  [key: string]: () => boolean,
} {
  return {
    // Onboarding
    isOnboardingUsingIntroScreenVersionA() {
      return featureRouter.isFeatureEnabled(onboardingIntroAFeature);
    },
    // Market
    areMarketPromptsEnabled() {
      return featureRouter.isFeatureEnabled(marketPromptsFeature);
    },

    // Signup
    isSignupEnabled() {
      return featureRouter.isFeatureEnabled(signupPlugin);
    },
    // Login
    isLoginLinkShownInSupport() {
      return featureRouter.isFeatureEnabled(disableLoginLinkFeature);
    },
    // Profile
    isKlikIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(klikPlugin);
    },
    isGithubProfileEnabled() {
      return featureRouter.isFeatureEnabled(githubProfileFeature);
    },
    // Preferences
    isAccountPrefsSectionHidden() {
      return featureRouter.isFeatureEnabled(hideAccountPrefsFeature);
    },
    // Availability
    isGoogleSyncEnabled() {
      return featureRouter.isFeatureEnabled(googleSyncPlugin);
    },
    isOutlookSyncEnabled() {
      return featureRouter.isFeatureEnabled(outlookSyncPlugin);
    },
    isManualAvailabilityEnabled() {
      return featureRouter.isFeatureEnabled(manualAvailabilityFeature);
    },
    isPersonalScheduleSyncEnabled() {
      return (
        featureRouter.isFeatureEnabled(googleSyncPlugin) ||
        featureRouter.isFeatureEnabled(outlookSyncPlugin) ||
        featureRouter.isFeatureEnabled(manualAvailabilityFeature)
      );
    },
    // Self check-in
    isSelfCheckInEnabled() {
      return featureRouter.isFeatureEnabled(selfCheckInPlugin);
    },
    // Notifications
    areEmailNotificationsEnabled() {
      return featureRouter.isFeatureEnabled(emailPlugin);
    },
    areSMSNotificationsEnabled() {
      return featureRouter.isFeatureEnabled(smsPlugin);
    },
    isNotificationPromptShown() {
      return featureRouter.isFeatureEnabled(emailPlugin);
    },
    // Third party integration
    isDoubleDutchIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(doubleDutchPlugin);
    },
    isSlackIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(slackPlugin);
    },
    isIframeIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(iframeIntegrationPlugin);
    },
    // Help
    isHelpEnabled() {
      return featureRouter.isFeatureEnabled(helpFeature);
    },
    // Navigation
    hasCustomMenu() {
      return featureRouter.isFeatureEnabled(customMenuPlugin);
    },
    // Moderation
    isModerationEnabled() {
      return featureRouter.isFeatureEnabled(moderationPlugin);
    },
    isTopicDisclaimerEnabled() {
      return featureRouter.isFeatureEnabled(topicDisclaimerPlugin);
    },

    // Light theme
    // @TODO - Remove this feature
    useLightTheme() {
      return featureRouter.isFeatureEnabled(lightThemeFeature);
    },

    // Video calls
    isVideoCallEnabled() {
      return featureRouter.isFeatureEnabled(videoCallPlugin);
    },

    isProvideFeedbackSectionEnabled() {
      return featureRouter.isFeatureEnabled(provideFeedbackSectionFeature);
    },

    isConversationFormatEnabled() {
      return featureRouter.isFeatureEnabled(conversationFormatsPlugin);
    },

    isRecommendedUserEnabled() {
      return featureRouter.isFeatureEnabled(userRecommendationFeature);
    },
    isFishbowlHotSeatEnabled() {
      return featureRouter.isFeatureEnabled(fishbowlHotseat);
    },
    isCustomFontEnabled() {
      return featureRouter.isFeatureEnabled(customFontPlugin);
    },
    isFishbowlEnabled() {
      return featureRouter.isFeatureEnabled(fishbowlFeature);
    },
    isSSOEnabled() {
      return featureRouter.isFeatureEnabled(ssoPlugin);
    },
    isGroupMessageModalEnabled() {
      return featureRouter.isFeatureEnabled(groupMessageModalFeature);
    },
    isInterestBasedBraindatingEnabled() {
      return featureRouter.isFeatureEnabled(interestBasedBraindatingFeature);
    },
    isTrendingKeywordsSectionEnabled() {
      return featureRouter.isFeatureEnabled(trendingKeywordsSectionFeature);
    },
    isVirtualBraindateRecordingsEnabled() {
      return featureRouter.isFeatureEnabled(virtualBraindateRecordingPlugin);
    },
    isExpressionOfGratitudeEnabled() {
      return featureRouter.isFeatureEnabled(expressionOfGratitudePlugin);
    },
    isAccessibilityCompatibleEnabled() {
      return featureRouter.isFeatureEnabled(accessibilityCompatibleFeature);
    },
    isTranscribeFeatureEnabled() {
      return featureRouter.isFeatureEnabled(transcribePlugin);
    },
    isRecommendationFeatureEnabled() {
      return featureRouter.isFeatureEnabled(topicRecommendationFeature);
    },
    isUserOnboardingFeatureEnabled() {
      return featureRouter.isFeatureEnabled(userOnboardingFeature);
    },
  };
}
